/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { _ as __assign } from '../../tslib.es6-e01eabb2.js';
import { I as index$c } from '../../index-e5fa4dec.js';
import { extend } from '../extend/index.js';
import saveImage$2 from './cnStation/index.js';
import saveImage$1 from './nebula/index.js';
import saveImage$3 from './panguMiniApp/index.js';
import mini from './mini/index.js';
import '../env/index.js';
import '../../index-f24a9ec1.js';
import '../../index-892d8eee.js';
import '../extend/register/index.js';
import '../../bridges/dd/index.js';
import '../../index-6f6b9acc.js';
import '../../_commonjsHelpers-56d33373.js';
import '../../loadscripts-cf212b8d.js';
import '../../constants-163bd007.js';
import '../../bridge-adpter-api-0316c034.js';
import '../../bridges/windvane/index.js';
import '../../bridges/nebula/index.js';
import '../../index.es-142c5680.js';
import '../../bridges/pangu-mini-app/index.js';
import '../../log-aabf3a34.js';
import '../../index-0bcce539.js';

// api: https://uni-apis.alibaba-inc.com/doc/Media/saveimage
var apiConfig = {
    web: {
        nebula: saveImage$1,
        windvane: {
            cnStation: saveImage$2,
        },
    },
    mini: mini,
    panguMiniApp: saveImage$3,
};
var extendSaveImage = extend(apiConfig, 
/** baseSaveImage 支持windvane容器 */
index$c);
/**
 * 保存图片。API：https://yuque.antfin.com/cn-xt/arch/lwbvd0
 * @param  {!string|SaveImageIOptions} url 图片地址或者base64。（目前已知windvane容器支持base64）
 * @param  {?SaveImageParams} params 当第一个参数为string格式时，此参数有效。
 * @returns {Promise<unknown>} promise调用结果

 * @example 使用案例：
 * import { saveImage } from '@alife/cn-uni-api';
 *
 *  saveImage('https://gw.alicdn.com/imgextra/i4/O1CN01tmIVdW22WftYPPH1O_!!6000000007128-2-tps-135-133.png'）
 *  .then(() => {
 *    console.log('success');
 *  })
 *  .catch((error) => {
 *    console.log(error);
 *  });
 * @author 敬文
 */
var saveImage = function (url, params) {
    if (typeof url === 'string') {
        return extendSaveImage(__assign(__assign({}, params), { url: url }));
    }
    return extendSaveImage(url);
};

export { extendSaveImage, saveImage };
